export default "__VITE_ASSET__38fa4ad2__"